import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { ConfigProvider } from 'antd';
import { createAntTheme } from 'ant-config';
import { getAdminColorScheme, setAdminColorScheme, } from 'lib/admin-color-scheme';
const AdminThemeContext = createContext(null);
export const useAdminTheme = () => {
    const ctx = useContext(AdminThemeContext);
    if (ctx === null) {
        throw new Error('useAdminTheme must be used within AdminThemeProvider');
    }
    return ctx;
};
export const AdminThemeProvider = ({ children }) => {
    const [colorScheme, setColorSchemeState] = useState(getAdminColorScheme);
    const setColorScheme = useCallback((scheme) => {
        setAdminColorScheme(scheme);
        setColorSchemeState(scheme);
    }, []);
    const value = useMemo(() => ({ colorScheme, setColorScheme }), [colorScheme, setColorScheme]);
    const antTheme = useMemo(() => createAntTheme(colorScheme), [colorScheme]);
    return (_jsx(AdminThemeContext.Provider, { value: value, children: _jsx(ConfigProvider, { theme: antTheme, children: children }) }));
};
